import { render, staticRenderFns } from "./OfficeWorkload.vue?vue&type=template&id=3f2b9d52"
import script from "./OfficeWorkload.vue?vue&type=script&lang=js"
export * from "./OfficeWorkload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports